import Layout from "./Layout";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { ForgotPassword } from "../Api/UserOperations/ForgotPassword";
import Swal from "sweetalert2";

export default function Login() {
  const { handleSubmit, handleChange, handleBlur, touched, values, errors } = useFormik({
    initialValues: {
      Email: "",
    },
    validationSchema: Yup.object({
      Email: Yup.string().email("Invalid email address").required("Email required!"),
    }),
    onSubmit: async (values) => {
      const { data } = await ForgotPassword(values);
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: data.status ? "success" : "error",
        title: `${data.msg}`,
      });
    },
  });

  return (
    <Layout>
      <section className="h-auto mx-auto max-w-screen-xl px-4">
        <div className="px-6 h-auto text-gray-800">
          <div className="flex xl:justify-center lg:justify-between justify-center items-center flex-wrap h-full g-6">
            <div className="grow-0 shrink-1 md:shrink-0 basis-auto xl:w-6/12 lg:w-6/12 md:w-9/12 mb-12 md:mb-0">
              <img
                src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
                className="w-full"
                alt="Sample"
              />
            </div>
            <div className="xl:ml-20 xl:w-5/12 lg:w-5/12 md:w-8/12 mb-12 md:mb-0">
              <form onSubmit={handleSubmit}>
                <p className=" text-lg font-light mt-2 pt-1 mb-0">Trouble Logging In?</p>
                <p className="text-sm font-light mt-2 pt-1 mb-0 py-5">
                  Enter your email we'll send you a link to get back into your account.
                </p>
                <div className="mb-6">
                  <input
                    onChange={handleChange}
                    value={values.Email}
                    onBlur={handleBlur}
                    name="Email"
                    type="text"
                    className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    placeholder="Email address"
                  />
                  {touched.Email && errors.Email && <span className="text-red-500 py-2">{errors.Email}</span>}
                </div>

                <div className="text-center lg:text-left">
                  <button
                    type="submit"
                    className="inline-block px-7 py-3 bg-blue-600 text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Send Login Link
                  </button>
                  <p className="text-sm font-semibold mt-2 pt-1 mb-0">
                    Don't have an account?
                    <Link
                      to="/Register"
                      className="text-red-600 hover:text-red-700 focus:text-red-700 transition duration-200 ease-in-out pl-1"
                    >
                      Register
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
